import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";

export type MatomoConsentPreferencesDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  draftAudienceEnabled: boolean;
  onDraftAudienceChange: (enabled: boolean) => void;
  onSave: () => void;
};

/**
 * Panneau de personnalisation cookies (MVP custom).
 * Brouillon local jusqu'à {@link MatomoConsentPreferencesDialogProps.onSave}.
 */
export function MatomoConsentPreferencesDialog({
  open,
  onOpenChange,
  draftAudienceEnabled,
  onDraftAudienceChange,
  onSave,
}: MatomoConsentPreferencesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" showCloseButton>
        <DialogHeader>
          <DialogTitle>Personnaliser les cookies</DialogTitle>
          <DialogDescription>
            Choisissez les cookies optionnels. Les cookies nécessaires restent
            toujours actifs.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <section className="rounded-lg border border-border/60 p-3">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 space-y-1">
                <h3 className="text-sm font-medium text-foreground">
                  Cookies nécessaires
                </h3>
                <p className="text-sm text-muted-foreground">
                  Requis pour la connexion et le fonctionnement du service.
                </p>
              </div>
              <Badge
                variant="outline"
                className="shrink-0 border-transparent bg-muted px-2 text-[11px] font-medium text-muted-foreground">
                Toujours actifs
              </Badge>
            </div>
          </section>

          <section className="rounded-lg border border-border/60 p-3">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 space-y-1">
                <h3 className="text-sm font-medium text-foreground">
                  Mesure d&apos;audience
                </h3>
                <p className="text-sm text-muted-foreground">
                  Matomo — statistiques de fréquentation anonymisées.
                </p>
              </div>
              <Switch
                checked={draftAudienceEnabled}
                onCheckedChange={onDraftAudienceChange}
                aria-label="Mesure d'audience Matomo"
              />
            </div>
          </section>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button type="button" onClick={onSave}>
            Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
